export default __webpack_public_path__ + "static/14-ff46efd2bdd4f3569e49c6aaf5baf579.jpg";